import IconButton from "./IconButton";
import { useAppSelector } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";
import Commander from "../../commander";

const FullscreenButton: React.FC<{}> = () => {
  const fullscreen = useAppSelector((state) => state.details.fullscreen);

  const { available, disabled } = useAppSelector(
    selectButton.bind(null, "fullscreen")
  );
  const type = fullscreen ? "FullscreenOff" : "FullscreenOn";
  const onClick = () => {
    Commander.toggleFullscreen(!fullscreen);
  };

  return (
    <IconButton
      name="fullscreen"
      available={available}
      onClick={onClick}
      disabled={disabled}
      type={type}
      soundEffect="button-click"
    />
  );
};

export default FullscreenButton;
